/* Bellany — Sistema de favoritos persistente (localStorage) */
(function () {
  'use strict';

  var KEY = 'bl-wishlist-v1';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function write(arr) {
    try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch (e) {}
    refreshUI();
  }
  function has(handle) {
    var list = read();
    return list.some(function (i) { return i.handle === handle; });
  }
  function toggle(handle, title, url, price, image) {
    var list = read();
    var idx = list.findIndex(function (i) { return i.handle === handle; });
    if (idx >= 0) {
      list.splice(idx, 1);
      write(list);
      return false;
    } else {
      list.push({ handle: handle, title: title, url: url, price: price, image: image, addedAt: Date.now() });
      write(list);
      return true;
    }
  }
  function remove(handle) {
    var list = read().filter(function (i) { return i.handle !== handle; });
    write(list);
  }
  function count() { return read().length; }

  function refreshUI() {
    var n = count();
    // badges
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.style.display = n > 0 ? '' : 'none';
    });
    // heart buttons
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-handle');
      if (has(handle)) {
        btn.classList.add('is-on');
        btn.setAttribute('aria-label', 'Remover dos favoritos');
      } else {
        btn.classList.remove('is-on');
        btn.setAttribute('aria-label', 'Adicionar aos favoritos');
      }
    });
  }

  function toast(msg) {
    var el = document.getElementById('bl-toast');
    if (!el) { el = document.createElement('div'); el.id = 'bl-toast'; el.className = 'bl-toast'; document.body.appendChild(el); }
    el.textContent = msg;
    el.hidden = false;
    el.classList.add('is-show');
    clearTimeout(window.__blWishToast);
    window.__blWishToast = setTimeout(function () {
      el.classList.remove('is-show');
      setTimeout(function () { el.hidden = true; }, 250);
    }, 2200);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-handle');
    var title = btn.getAttribute('data-title') || 'Produto';
    var url = btn.getAttribute('data-url') || '#';
    var price = btn.getAttribute('data-price') || '';
    var image = btn.getAttribute('data-image') || '';
    var added = toggle(handle, title, url, price, image);
    toast(added ? '❤ Adicionado aos favoritos' : 'Removido dos favoritos');
    btn.classList.toggle('is-on', added);
  });

  // Public API
  window.blWishlist = { read: read, toggle: toggle, remove: remove, has: has, count: count, refreshUI: refreshUI };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshUI);
  } else {
    refreshUI();
  }
})();
